const state = {
  isProcessing: false,
  taskId: null,
  processingStatus: null,
  processingStartTime: null,
};

// getters
const getters = {
  isRenewableProcessing: (state) => state.isProcessing,
  renewableTaskId: (state) => state.taskId,
  renewableProcessingStatus: (state) => state.processingStatus,
};

// mutations
const mutations = {
  SET_PROCESSING(state, isProcessing) {
    state.isProcessing = isProcessing;
    if (isProcessing) {
      state.processingStartTime = new Date();
    } else {
      state.processingStartTime = null;
    }
  },
  SET_TASK_ID(state, taskId) {
    state.taskId = taskId;
  },
  SET_PROCESSING_STATUS(state, status) {
    state.processingStatus = status;
  },
  CLEAR_PROCESSING_STATE(state) {
    state.isProcessing = false;
    state.taskId = null;
    state.processingStatus = null;
    state.processingStartTime = null;
  },
};

// actions
const actions = {
  startRenewableProcessing({ commit }, taskId) {
    commit('SET_PROCESSING', true);
    commit('SET_TASK_ID', taskId);
    commit('SET_PROCESSING_STATUS', 'PENDING');
  },
  updateProcessingStatus({ commit }, status) {
    commit('SET_PROCESSING_STATUS', status);
  },
  completeRenewableProcessing({ commit }) {
    commit('SET_PROCESSING', false);
    commit('SET_PROCESSING_STATUS', 'SUCCESS');
    setTimeout(() => {
      commit('CLEAR_PROCESSING_STATE');
    }, 1000);
  },
  failRenewableProcessing({ commit }) {
    commit('SET_PROCESSING', false);
    commit('SET_PROCESSING_STATUS', 'FAILURE');
    setTimeout(() => {
      commit('CLEAR_PROCESSING_STATE');
    }, 1000);
  },
  clearRenewableProcessing({ commit }) {
    commit('CLEAR_PROCESSING_STATE');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};